<div
  mdbModal
  #modal="mdbModal"
  class="modal fade top lower-modal"
  id="frameModalTop"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" *ngIf="!completed">
      <div class="modal-body">
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <br />

        <div class="header">
          <span class="redText">{{ Localization.Decline | translate }}</span>
          <span *ngIf="!!type">&nbsp;-&nbsp;{{ type | translateEnum: 'actionType' }}</span>
          <span *ngIf="!type"> - {{ Localization.DeclineJobsCount | translate:{count: ids?.length} }}</span>
        </div>
        <span>
          <i class="fa fa-comment gray mr-2 w-14"></i>&nbsp;{{ Localization.Feedback | translate }}
        </span>
        <chapps-text-area-input [rows]="3" [control]="feedbackFC">
        </chapps-text-area-input>
        <br />
        <span> <i class="fa fa-images gray mr-2 w-14"></i>{{ Localization.Media | translate }}</span>
        <div id="images-container" class="mb-2">
          <chapps-image
            *ngFor="let photo of photos; index as i"
            [id]="photo"
            [url]="photo"
            (deleted)="onPhotoDelete(i)"
          >
          </chapps-image>
          <chapps-image-selector
            *ngIf="photos.length < 5"
            (changed)="onPhotoSelected($event)"
          >
          </chapps-image-selector>
        </div>
        <chapps-image-cropper-modal
          (fileCropped)="fileCropped($event)"
        ></chapps-image-cropper-modal>
      </div>
      <div class="modal-footer text-right">
        <chapps-secondary-button
          [disabled]="submitting"
          [label]="Localization.Submit | translate"
          (clicked)="decline()"
          [small]="true"
        >
        </chapps-secondary-button>
      </div>
    </div>
    <div class="modal-content" *ngIf="completed">
      <div class="modal-body">
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <br />

        <div class="header">
          <span class="greenText">{{ 'Declined' | translateEnum: 'actionStatusType' }}</span>
          <span>&nbsp;-&nbsp;{{ type | translateEnum: 'actionType' }}</span>
        </div>
        <span>
          <i class="fa fa-comment gray mr-2 w-14"></i>{{ Localization.YouDeclinedThisJob | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
